import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/user_corp_emails'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
}
